/***
 * @file:è®¾ç½®é¡¹ç®ä¿¡æ¯
 * @author: linkun.he
 * @Date: 2020-01-03 16:03:37
 */
import { Injectable } from '@angular/core';
import { SettingsService } from './setting.service';

@Injectable({ providedIn: 'root' })
export class SetProjectInfoService {
  constructor(private settingsrv: SettingsService) {}

  set(logo?: string, projectName?: string) {
    const userConfig = this.settingsrv.userConfig || {};
    const themeConfig = userConfig['theme'] || {};
    themeConfig.logo = logo || themeConfig.logo;
    themeConfig.projectName = projectName;
    this.settingsrv.setUserConfig(userConfig);
  }
}
